export default {
  fontFamily: ["Roboto", '"Helvetica Neue"', "Arial", "sans-serif"].join(","),
  useNextVariants: true,
  h2: {
    fontSize: 36
  }
};
